import SubscribeButton from '@/creditflowresearch/ui/components/deals/DealListTable/components/SubscribeButtonContainer';
import { ProfileTypes } from '@/creditflowresearch/application/actions/profile/constants';
import Flex from '@creditflowresearch/uilib/Flex';
import TogglingFilters from '@/creditflowresearch/ui/common/components/TogglingFilters';
import memoize from '@framework/data-helpers/memoize';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import keyResolver from '@framework/data-helpers/keyResolver';
import { useDealStatusContext } from '@/creditflowresearch/application/Deal/contexts/DealStatusContext';
import { useProductsContext } from '@/creditflowresearch/application/Deal/contexts/ProductsContext';
import { useDealContext } from '@/creditflowresearch/application/Deal/helpers/productContext/useDealContext';
import { useRowsExpandedContext } from '@/creditflowresearch/application/Deal/contexts/RowsExpandedContext';
import TriggerExpand from '@creditflowresearch/uilib/TriggerExpand';
import Links from './Links';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/components/HeaderActions/headerActions.module.scss';

interface IHeaderActionsProps {
  profileType?: ProfileTypes,
  showDealStatusFilters?: boolean,
}

export const getDealIds = memoize((deals) => deals.map((deal) => deal.id) || [], keyResolver);

export const HeaderActions = ({
  showDealStatusFilters = true,
  profileType,
}: IHeaderActionsProps) => {
  const { activeProduct } = useProductsContext();
  const {
    collection,
    isFetching,
    subscribeButtonText,
    subscribeSuccessMessage,
    subscriptions,
    markSubscribed,
  } = useDealContext(activeProduct);
  const {
    includedProductIds,
    includedRegionIds,
  } = usePageFiltersContext();
  const { filterStatusSet, applyDealStatus } = useDealStatusContext();
  const { isRowsExpanded, setIsRowsExpanded } = useRowsExpandedContext();
  const { subscriptionRequiredPlan, isSubscribed, subscriptionId } = subscriptions || {};
  const dealIds = getDealIds(collection);
  const isAllStatusesSelected = filterStatusSet.dealStatus.items.every((item) => item.isActive);
  const [productId] = includedProductIds;
  const [regionId] = includedRegionIds;
  const noData = !dealIds?.length && !isFetching;

  return (
    <Flex
      align={ { sm: 'stretch', md: 'center', xl: 'center' } }
      direction={ { sm: 'column', md: 'row' } }
      gap={ 10 }
    >
      { showDealStatusFilters && (
        <div className={ styles.dealStatusFiltersWrapper }>
          <TogglingFilters
            isDisabled={ noData && isAllStatusesSelected }
            applyFilter={ applyDealStatus }
            filterSet={ filterStatusSet }
            isTooltipEnabled={ false }
            activeClassName={ styles.dealStatusFiltersActive }
          />
        </div>
      ) }
      <Flex align={ { sm: 'baseline', md: 'center', xl: 'center' } } gap={ 10 } wrap={ { sm: 'wrap', md: 'wrap' } }>
        <SubscribeButton
          variant="outline"
          label={ subscribeButtonText }
          successMessage={ subscribeSuccessMessage }
          isSubscribeAvailable={ !!(regionId && productId && profileType === ProfileTypes.OVERVIEW) }
          requiredPlan={ subscriptionRequiredPlan }
          isSubscribed={ isSubscribed }
          subscriptionId={ subscriptionId }
          onSubscribed={ markSubscribed }
        />

        <Links />
        <div className={ styles.triggerExpand }>
          <TriggerExpand
            isRowsExpanded={ isRowsExpanded }
            setIsRowsExpanded={ setIsRowsExpanded }
            disabled={ noData }
          />
        </div>
      </Flex>
    </Flex>
  );
};
